import React from "react";
import { motion } from "framer-motion";
import { PublicLayout } from "../components/Layout";

const LEADERS = [
  {
    id: "founder", name: "Late Shri K M Muthiah", role: "Visionary Behind the Legacy", tenure: "1955 — Legacy", tier: "gold",
    bio: "The pioneer whose vision, in 1955, gave shape to R K STEEL. His conviction that integrity outlasts every industrial cycle continues to guide every commitment we honour today.",
  },
  {
    id: "proprietor", name: "Ravichandran", role: "Founder & Proprietor", tenure: "Present", tier: "gold",
    bio: "The architect of R K STEEL's global evolution. Under his stewardship, a principled regional trader has grown into a globally respected industrial procurement and recycling organization — rooted in trust and long-term relationships.",
  },
  {
    id: "director-1", name: "R. Karthik Kumar", role: "Head — Operations & Strategic Procurement", tenure: "Present", tier: "board",
    bio: "Leads global operational excellence, strategic procurement and long-term industrial partnerships — ensuring quality, efficiency and sustainable business growth.",
  },
  {
    id: "director-2", name: "R. Rahul Kumar", role: "Head — Global Business Development", tenure: "Present", tier: "board",
    bio: "Steers international market development, export corridors and long-term client partnerships — extending R K STEEL's global footprint while preserving the founding ethos.",
  },
  {
    id: "manager", name: "K. Vadivelu", role: "Manager", tenure: "Present", tier: "manager",
    bio: "The operational spine — orchestrating day-to-day execution, quality assurance, and client fulfilment with quiet mastery.",
  },
];

const Team = () => (
  <PublicLayout>
    <section className="pt-28 md:pt-32 pb-16 md:pb-20 bg-[#222629] text-white relative overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 relative">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8823E] mb-4">Leadership</div>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight max-w-3xl leading-[1.05]">
          The people behind seven decades of steel.
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-neutral-300 max-w-2xl leading-relaxed">
          A family-led enterprise. A team of professionals. One shared responsibility — to preserve the trust, integrity, and vision established in 1955.
        </p>
      </div>
    </section>

    <section className="py-16 md:py-28 bg-[#F7F8F5]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {LEADERS.map((l, i) => (
          <motion.div
            key={l.id}
            data-testid={`team-card-${l.id}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`lift-card relative bg-white rounded-2xl p-8 border ${l.tier === "gold" ? "border-[#B8823E]/50 glow-gold" : "border-neutral-200"} ${i === 0 ? "lg:col-span-2" : ""}`}
          >
            {l.tier === "gold" && <div className="absolute top-4 right-4 text-[10px] tracking-[0.3em] uppercase text-[#B8823E]">Legacy</div>}
            <div className="w-20 h-20 rounded-full bg-[#12355B] text-[#B8823E] flex items-center justify-center font-display font-semibold text-2xl">
              {l.name.replace("Late ", "").split(" ").map(w => w[0]).slice(0, 2).join("")}
            </div>
            <div className="mt-5">
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#2F9E44]">{l.role}</div>
              <h3 className="font-heading text-2xl font-semibold text-[#222629] mt-1.5 leading-tight">{l.name}</h3>
              <div className="text-xs text-neutral-500 mt-1">{l.tenure}</div>
              <p className="mt-4 text-neutral-700 leading-relaxed text-sm">{l.bio}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  </PublicLayout>
);

export default Team;
